// PRD.275 — Elia AI Assistant Drawer (Phase 1, UI only).
//
// Pure helpers for message presentation, kept out of the React components so
// they can be unit-tested (see elia-chat.test.ts).

/** Above this length an assistant bubble collapses to a preview (FR-15). */
export const ELIA_COLLAPSE_THRESHOLD = 220;

export const ELIA_COLLAPSED_LINES = 4;

/** Whether an assistant message is long enough to warrant Show more / less. */
export function isCollapsibleAssistantContent(content: string): boolean {
  return content.length > ELIA_COLLAPSE_THRESHOLD;
}
